import { FaChartLine, FaEye, FaGlobe, FaInfoCircle, FaRobot, FaStoreAlt } from 'react-icons/fa';

const features = [
  {
    icon: FaChartLine,
    title: "Real-Time Analytics",
    description: "Track every click, view duration, and interaction. Know exactly which items attract attention and drive sales with second-by-second precision."
  },
  {
    icon: FaRobot,
    title: "AI Waiter Personalities",
    description: "Choose from 4 AI personalities Lebanese Casual, Professional English, Quick Service, or Chef Expert. Your AI assistant handles questions, suggests items, and collects feedback 24/7."
  },
  {
    icon: FaStoreAlt,
    title: "Multi-Branch Management",
    description: "Easily manage multiple restaurant branches. Log in, select your branch, and access a dedicated dashboard for custom analytics, menus, and settings each branch operates independently."
  },
  {
    icon: FaInfoCircle,
    title: "Comprehensive Item Details",
    description: "Every dish includes calories, prep time, ingredients, spice level, and dietary tags (Halal, Vegetarian, Keto, etc.). Help customers make informed decisions instantly."
  },
  {
    icon: FaGlobe,
    title: "Bilingual Support",
    description: "Full English and Arabic support for menus, descriptions, and AI responses. Serve diverse customers with seamless language switching."
  },
  {
    icon: FaEye,
    title: "Engagement Tracking",
    description: "See how long customers look at each item, which categories get the most attention, and what days of the month drive peak engagement."
  }
]

const testimonials = [
    {
      name: "Maria Rodriguez",
      role: "Owner, Casa Bella",
      image:
        "https://images.unsplash.com/photo-1524253482453-3fed8d2fe12b?w=100&h=100&fit=crop&crop=face",
      text: "This platform transformed our business! Orders increased by 300% in just 2 months.",
      rating: 5
    },
    {
      name: "Ahmed Al-Hassan",
      role: "Manager, Spice Garden",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
      text: "The multi-language support helped us reach customers we never could before.",
      rating: 5
    },
    {
      name: "Sophie Chen",
      role: "Owner, Dragon Palace",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
      text: "Beautiful design and so easy to use. Our customers love the new digital menu!",
      rating: 5
    },
    {
      name: "John Smith",
      role: "Chef, Urban Eats",
      image:
        "https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=100&h=100&fit=crop&crop=face",
      text: "Analytics helped us discover our best-selling dishes and improve our menu.",
      rating: 4
    },
    {
      name: "Fatima Zahra",
      role: "Owner, Marrakech Delights",
      image:
        "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=100&h=100&fit=crop&crop=face",
      text: "Fast loading and WhatsApp orders made a huge difference during busy hours.",
      rating: 5
    },
    {
      name: "Luca Bianchi",
      role: "Manager, Trattoria Roma",
      image:
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=100&h=100&fit=crop&crop=face",
      text: "Custom branding gave our restaurant a unique digital identity.",
      rating: 4
    }
];

const Plans = [
  {
    name: "Dine Core",
    desc: "Perfect for getting started with digital menus",
    price: "$19",
    setup: "$199 one-time setup fee",
    monthly: "/month",
    border: "border-orange-100",
    extras: [
      { label: "Setup fee", value: "$99" },
      { label: "Monthly fee", value: "$9/mo" }
    ],
    features: [
      "Unlimited menu items",
      "Full management features",
      "Real-time menu updates",
      "Mobile-friendly interface"
    ],
    highlight: false
  },
  {
    name: "Dine AI",
    desc: "Enhanced with AI-powered customer support",
    price: "$44",
    setup: "$249 one-time setup fee",
    monthly: "/month",
    border: "border-orange-500/50",
    extras: [
      { label: "Setup fee", value: "$149" },
      { label: "Monthly fee", value: "$34/mo" }
    ],
    features: [
      "Everything in Dine Core",
      "AI chatbot for customer queries",
      "Fair usage limit included",
      "Pay-as-you-go beyond limit",
      "24/7 automated responses"
    ],
    highlight: true,
  },
];

const navItems = [
  { name: "Features", to: "features" },
  { name: "Analytics", to: "analytics" },
  { name: "AI Chatbot", to: "ai-chatbot" },
  { name: "Multi-Branch", to: "multi-branch" },
  // { name: "Pricing", to: "pricing" },
  { name: "Contact", to: "contact" }
];

const WhatsappLink = "https://api.whatsapp.com/send?phone=9613364257&text=Hello%20Dina.ai!%20I%20want%20to%20Create%20My%20Menu.";

export { features, testimonials, Plans, navItems, WhatsappLink };